module.exports = __webpack_public_path__ + "static/nodal-structure-f6c3c4ad29c902596f9b55d94db90563.png";